import mini_1 from './carImages/远程星智/mini.png';
import focus_1 from './carImages/远程星智/focus.png';
import introduce_1 from './carImages/远程星智/introduce.png';

import mini_2 from './carImages/远程星享/mini.png';
import focus_2 from './carImages/远程星享/focus.png';
import introduce_2 from './carImages/远程星享/introduce.png';

import mini_3 from './carImages/远程E6/mini.png';
import focus_3 from './carImages/远程E6/focus.png';
import introduce_3 from './carImages/远程E6/introduce.png';

import mini_4 from './carImages/远程锋锐F3E厢式车/mini.png';
import focus_4 from './carImages/远程锋锐F3E厢式车/focus.png';
import introduce_4 from './carImages/远程锋锐F3E厢式车/introduce.png';

import mini_5 from './carImages/远程锋锐F3E平板车/mini.png';
import focus_5 from './carImages/远程锋锐F3E平板车/focus.png';
import introduce_5 from './carImages/远程锋锐F3E平板车/introduce.png';

import mini_6 from './carImages/远程GLR增程式冷藏车/mini.png';
import focus_6 from './carImages/远程GLR增程式冷藏车/focus.png';
import introduce_6 from './carImages/远程GLR增程式冷藏车/introduce.png';

import mini_7 from './carImages/远程GLR增程式厢式车/mini.png';
import focus_7 from './carImages/远程GLR增程式厢式车/focus.png';
import introduce_7 from './carImages/远程GLR增程式厢式车/introduce.png';

import mini_8 from './carImages/远程G7E/mini.png';
import focus_8 from './carImages/远程G7E/focus.png';
import introduce_8 from './carImages/远程G7E/introduce.png';

import mini_9 from './carImages/远程E200厢式车/mini.png';
import focus_9 from './carImages/远程E200厢式车/focus.png';
import introduce_9 from './carImages/远程E200厢式车/introduce.png';

import mini_10 from './carImages/远程E200仓栅车/mini.png';
import focus_10 from './carImages/远程E200仓栅车/focus.png';
import introduce_10 from './carImages/远程E200仓栅车/introduce.png';

import mini_11 from './carImages/远程E200S厢式车/mini.png';
import focus_11 from './carImages/远程E200S厢式车/focus.png';
import introduce_11 from './carImages/远程E200S厢式车/introduce.png';

import mini_12 from './carImages/远程E200S冷藏车/mini.png';
import focus_12 from './carImages/远程E200S冷藏车/focus.png';
import introduce_12 from './carImages/远程E200S冷藏车/introduce.png';

import mini_13 from './carImages/远程E200S平板车/mini.png';
import focus_13 from './carImages/远程E200S平板车/focus.png';
import introduce_13 from './carImages/远程E200S平板车/introduce.png';

import mini_14 from './carImages/远程E5L/mini.png';
import focus_14 from './carImages/远程E5L/focus.png';
import introduce_14 from './carImages/远程E5L/introduce.png';

import mini_15 from './carImages/远程E5/mini.png';
import focus_15 from './carImages/远程E5/focus.png';
import introduce_15 from './carImages/远程E5/introduce.png';

let carData = {
    2: {
        id: 2,
        name: '远程星智', //名字
        type: '轻卡', // 车型
        GKXH: ['≥260'], // 工况续航(km)
        ZCRS: [2,3],
        ZDZF: [17, 18.3], // 最大载方(m³)
        ZCCC: ['5.995*2.15*2.98/3.13'],
        HXCC: ['4.15*2.1*1.95/2.1'],
        DL: [89.1, 86.6],// 电量(度)
        img:focus_1,//焦点图
        detailImg:introduce_1,//介绍图
        miniImg:mini_1,//小图
        PP: '吉利',
        DDCJ: ['宁德时代', '亿纬锂能'], // 电芯厂家
    },
    3: {
        id: 3,
        name: '远程星享', //名字
        type: '轻客', // 车型
        GKXH: ['≥260'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [6], // 最大载方(m³)
        ZCCC: ['4.845*1.73*1.985'],
        HXCC: ['2.8*1.6*1.32'],
        DL: [41.86],// 电量(度)
        img:focus_2,//焦点图
        detailImg:introduce_2,//介绍图
        miniImg:mini_2,//小图
        PP: '吉利',
        DDCJ: ['宁德时代'], // 电芯厂家
    },
    4: {
        id: 4,
        name: '远程E6', //名字
        type: '轻客', // 车型
        GKXH: ['≥235'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [7, 7.8], // 最大载方(m³)
        ZCCC: ['5.45*1.7*2.16/1.995'],
        HXCC: ['3.4*1.54*1.5/1.34'],
        DL: [50.23, 41.86],// 电量(度)
        img:focus_3,//焦点图
        detailImg:introduce_3,//介绍图
        miniImg:mini_3,//小图
        PP: '吉利',
        DDCJ: ['宁德时代'], // 电芯厂家
    },
    5: {
        id: 5,
        name: '远程锋锐F3E厢式车', //名字
        type: '微卡', // 车型
        GKXH: ['≥255'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [11], // 最大载方(m³)
        ZCCC: ['5.845*1.8*2.72', '5.76*1.85*2.67'],
        HXCC: ['3.7*1.75*1.7'],
        DL: [55.7, 61.8],// 电量(度)
        img:focus_4,//焦点图
        detailImg:introduce_4,//介绍图
        miniImg:mini_4,//小图
        PP: '吉利',
        DDCJ: ['宁德时代', '亿纬锂能'], // 电芯厂家
    },
    6: {
        id: 6,
        name: '远程锋锐F3E平板车', //名字
        type: '微卡', // 车型
        GKXH: ['≥270'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [], // 最大载方(m³)
        ZCCC: ['5.845*1.8*2.06','5.76*1.85*2.06'],
        HXCC: ['3.7*1.75*0.36'],
        DL: [55.7, 61.8],// 电量(度)
        img:focus_5,//焦点图
        detailImg:introduce_5,//介绍图
        miniImg:mini_5,//小图
        PP: '吉利',
        DDCJ: ['宁德时代', '亿纬锂能'], // 电芯厂家
    },
    7: {
        id: 7,
        name: '远程GLR增程式冷藏车', //名字
        type: '轻卡', // 车型
        GKXH: ['≥500（油电）'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [16.8], // 最大载方(m³)
        ZCCC: ['5.995*2.35*3.05/3.08'],
        HXCC: ['4.02*2.2*1.9'],
        DL: [53.58,54.72],// 电量(度)
        img:focus_6,//焦点图
        detailImg:introduce_6,//介绍图
        miniImg:mini_6,//小图
        PP: '吉利',
        DDCJ: ['国轩高科', '亿纬锂能'], // 电芯厂家
    },
    8: {
        id: 8,
        name: '远程GLR增程式厢式车', //名字
        type: '轻卡', // 车型
        GKXH: ['≥500（油电）'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [17.8, 20.9], // 最大载方(m³)
        ZCCC: ['5.995*2.2*3.05','5.995*2.35*3.25'],
        HXCC: ['4.14*2.15*2','4.14*2.3*2.2'],
        DL: [53.58, 54.72],// 电量(度)
        img:focus_7,//焦点图
        detailImg:introduce_7,//介绍图
        miniImg:mini_7,//小图
        PP: '吉利',
        DDCJ: ['国轩高科', '亿纬锂能'], // 电芯厂家
    },
    9: {
        id: 9,
        name: '远程G7E', //名字
        type: '轻卡', // 车型
        GKXH: ['>200'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [17], // 最大载方(m³)
        ZCCC: ['5.995*2.1*3.02'],
        HXCC: ['4.14*2.05*2'],
        DL: [81.14],// 电量(度)
        img:focus_8,//焦点图
        detailImg:introduce_8,//介绍图
        miniImg:mini_8,//小图
        PP: '吉利',
        DDCJ: ['宁德时代'], // 电芯厂家
    },
    10: {
        id: 10,
        name: '远程E200厢式车', //名字
        type: '轻卡', // 车型
        GKXH: ['>200'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [17, 18.2], // 最大载方(m³)
        ZCCC: ['5.995*2.1*2.995/3.02/3.05/3.145/3.17','5.995*2.15*3.095'],
        HXCC: ['4.14*2.05*2/2.15','4.14*2.1*2.1'],
        DL: [86.55,96.76,80.64,'86 等'],// 电量(度)
        img:focus_9,//焦点图
        detailImg:introduce_9,//介绍图
        miniImg:mini_9,//小图
        PP: '吉利',
        DDCJ: ['宁德时代','亿纬锂能','国轩高科 等'], // 电芯厂家
    },
    11: {
        id: 11,
        name: '远程E200仓栅车', //名字
        type: '轻卡', // 车型
        GKXH: ['≥480'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [], // 最大载方(m³)
        ZCCC: ['5.995*2.2*3.13'],
        HXCC: ['4.1*2.1*0.4'],
        DL: [106.95],// 电量(度)
        img:focus_10,//焦点图
        detailImg:introduce_10,//介绍图
        miniImg:mini_10,//小图
        PP: '吉利',
        DDCJ: ['宁德时代'], // 电芯厂家
    },
    12: {
        id: 12,
        name: '远程E200S厢式车', //名字
        type: '微卡', // 车型
        GKXH: ['≥270'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [10.4,11.2], // 最大载方(m³)
        ZCCC: ['5.59*1.83*2.66','5.65*1.85*2.68'],
        HXCC: ['3.5*1.74*1.7','3.6*1.75*1.78'],
        DL: [66.84,54.72],// 电量(度)
        img:focus_11,//焦点图
        detailImg:introduce_11,//介绍图
        miniImg:mini_11,//小图
        PP: '吉利',
        DDCJ: ['宁德时代','国轩高科'], // 电芯厂家
    },
    13: {
        id: 13,
        name: '远程E200S冷藏车', //名字
        type: '微卡', // 车型
        GKXH: ['≥295'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [9.3], // 最大载方(m³)
        ZCCC: ['5.6*1.86*2.69'],
        HXCC: ['3.4*1.65*1.65'],
        DL: [66.84],// 电量(度)
        img:focus_12,//焦点图
        detailImg:introduce_12,//介绍图
        miniImg:mini_12,//小图
        PP: '吉利',
        DDCJ: ['宁德时代'], // 电芯厂家
    },
    14: {
        id: 14,
        name: '远程E200S平板车', //名字
        type: '微卡', // 车型
        GKXH: ['≥270'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [], // 最大载方(m³)
        ZCCC: ['5.615*1.83*2.14'],
        HXCC: ['3.58*1.75*0.36'],
        DL: [54.72],// 电量(度)
        img:focus_13,//焦点图
        detailImg:introduce_13,//介绍图
        miniImg:mini_13,//小图
        PP: '吉利',
        DDCJ: ['国轩高科'], // 电芯厂家
    },
    15: {
        id: 15,
        name: '远程E5L', //名字
        type: '微面', // 车型
        GKXH: ['≥280'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [5.28,5], // 最大载方(m³)
        ZCCC: ['4.495*1.68*1.99'],
        HXCC: ['2.5/2.68*1.48*1.33'],
        DL: [41.86,39.9],// 电量(度)
        img:focus_14,//焦点图
        detailImg:introduce_14,//介绍图
        miniImg:mini_14,//小图
        PP: '吉利',
        DDCJ: ['宁德时代','国轩高科'], // 电芯厂家
    },
    16: {
        id: 16,
        name: '远程E5', //名字
        type: '微面', // 车型
        GKXH: ['≥260'], // 工况续航(km)
        ZCRS: [],
        ZDZF: [3.9], // 最大载方(m³)
        ZCCC: ['4.15*1.62*1.905'],
        HXCC: ['2.06*1.47*1.29'],
        DL: [39.6],// 电量(度)
        img:focus_15,//焦点图
        detailImg:introduce_15,//介绍图
        miniImg:mini_15,//小图
        PP: '吉利',
        DDCJ: ['星恒电源'], // 电芯厂家
    },
};

export {carData};


// WEBPACK FOOTER //
// ./src/marketingOnline/data/carData.js